<template>
  <div class="image-finetune" :class="{'image-finetune--mobile': isMobile }">
    <pintura-editor
      v-bind="editorProps"
      :src="props.src"
      :utils="['finetune']"
      :enableButtonClose="false"
      :enableButtonExport="false"
      :enableButtonRevert="false"
      :previewUpscale="true"
      ref="pinturaEditorRef"
    />
    <div class="image-finetune__bottom">
      <v-spacer />
      <ai-button v-if="props.actions.indexOf('reset') !== -1" theme="dark" @click="resetHandler">
        {{ $t('services.reset') }}
      </ai-button>
      <ai-button v-if="props.actions.indexOf('back') !== -1" theme="dark" @click="backHandler">
        {{ $t('common.back') }}
      </ai-button>
      <ai-button v-if="props.actions.indexOf('save') !== -1" theme="gradient" @click="editHandler">
        {{ $t('profile.save') }}
      </ai-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType, ref, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { PinturaEditor } from '@pqina/vue-pintura';
import { getEditorDefaults } from '@pqina/pintura';

import { useCommonStore } from '@/store/common';

import { fileToDataURL } from '@/helpers/fileToDataURL';

import AiButton from '@/components/UI/AiButton/AiButton.vue';

import localeRu from '@/assets/pintura/ru.json';

const { isMobile } = storeToRefs(useCommonStore());

const pinturaEditorRef = ref<any | null>(null);
const editorProps = ref(getEditorDefaults());

const props = defineProps({
  actions: {
    type: Array as PropType<string[]>,
    default: () => ['reset', 'back', 'save'],
  },
  src: {
    type: String as PropType<string>,
    required: true,
  },
});

const emits = defineEmits(['save', 'reset', 'back']);

const resetHandler = (): void => {
  emits('reset');
};

const backHandler = (): void => {
  emits('back');
};

const editHandler = (): void => {
  pinturaEditorRef.value.editor.processImage().then(async (res: any) => {
    const imageData = await fileToDataURL(res.dest);
    emits('save', imageData);
  });
};

onMounted(async () => {
  editorProps.value = { ...getEditorDefaults(), locale: { ...getEditorDefaults().locale, ...localeRu } };
});
</script>

<style scoped lang="scss" src="./ImageFinetune.scss" />
